import {UsefulLinksItemCasino888CipBox} from "./useful-links-item.casino888.cip.box";

export const UsefulLinksItemCasino888CisBox = UsefulLinksItemCasino888CipBox;
